<script>
   /**************************************************************/
   /* Svelte component for DistancePlot settings               */
   /**************************************************************/

   import Container from '../../../shared/controls/Container.svelte';
   import Select from '../../../shared/controls/Select.svelte';

   export let params;
   export let res;

   let scope = 'objects';
   let distType = 'f';
   let showLabels = 'hide';
   let resID = 'both';

   $: params = {
      scope,
      distType,
      showLabels,
      resID
   }
</script>

{#if res  }
<Container label="">
   <p class="title">Distance plot (objects)</p>
</Container>
{#if Object.keys(res).length > 1 }
<Container label='Results:'>
   <Select id='resType' bind:value={resID} options={[...Object.keys(res), 'both', 'diff']} />
</Container>
{/if}
<Container label='Distances:'>
   <Select id='distances' bind:value={distType} options={['h', 'q', 'f']} />
</Container>
<Container label='Labels:'>
   <Select id='showLabels' bind:value={showLabels} options={['hide', 'show']} />
</Container>
{/if}

